import { useState } from 'react';
import { Context } from './Context';
export function FileSystemAccessManagementProvider(props) {
    const { children } = props;
    const [entryId, setEntryId] = useState(undefined);
    const value = { entryId, setEntryId, open: Boolean(entryId) };
    return <Context.Provider value={value}>{children}</Context.Provider>;
}
